import { type FC, Fragment } from "react";
import { Table } from "@root/shared/components/Table/legacy/Table";
import { Th } from "@root/shared/components/Table/legacy/Th";
import { Td } from "@root/shared/components/Table/legacy/Td";
import { Tr } from "@root/shared/components/Table/legacy/Tr";
import { Label } from "@root/shared/components/Label/legacy";
import * as styles from "./styles.css";

export type basicHopedConditionsProps = {
  hopedJobTypes?: string[];
  hopedEmploymentPatterns?: string;
  experiences?: string[];
  nationalQualificationsHopeJobType?: string;
  credentials?: string[];
  address?: string;
  nearestStation?: string;
};

type Props = {
  basicHopedConditions: basicHopedConditionsProps;
};

export const BasicHopedConditionsTable: FC<Props> = ({
  basicHopedConditions: {
    hopedJobTypes,
    hopedEmploymentPatterns,
    experiences,
    nationalQualificationsHopeJobType,
    credentials,
    address,
    nearestStation,
  },
}) => (
  <Table>
    {hopedJobTypes && (
      <Tr>
        <Th>希望職種</Th>
        <Td>
          {hopedJobTypes?.map((hopedJobType) => (
            <Fragment key={hopedJobType}>
              {hopedJobType}
              <br />
            </Fragment>
          ))}
        </Td>
      </Tr>
    )}
    {hopedEmploymentPatterns && (
      <Tr>
        <Th>希望雇用形態</Th>
        <Td>{hopedEmploymentPatterns}</Td>
      </Tr>
    )}
    {nationalQualificationsHopeJobType && (
      <Tr>
        <Th>資格区分</Th>
        <Td>{nationalQualificationsHopeJobType}</Td>
      </Tr>
    )}
    {experiences && (
      <Tr>
        <Th>経験職種</Th>
        <Td>
          {experiences?.map((experience) => (
            <Fragment key={experience}>
              {experience}
              <br />
            </Fragment>
          ))}
        </Td>
      </Tr>
    )}
    {credentials && (
      <Tr>
        <Th>保有資格</Th>
        <Td>
          <ul className={styles.labelList}>
            {credentials?.map((credential) => (
              <li key={credential}>
                <Label size="medium" filledType="outlined" color="pink" bold>
                  {credential}
                </Label>
              </li>
            ))}
          </ul>
        </Td>
      </Tr>
    )}
    {address && (
      <Tr>
        <Th>住所</Th>
        <Td>{address}</Td>
      </Tr>
    )}
    {nearestStation && (
      <Tr>
        <Th>最寄り駅</Th>
        <Td>{nearestStation}</Td>
      </Tr>
    )}
  </Table>
);
